import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=830e7fa0&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"
import style0 from "./MainView.vue?vue&type=style&index=0&id=830e7fa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830e7fa0",
  null
  
)

export default component.exports